









































































































































































/* eslint-disable class-methods-use-this */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import Application from '@/models/map-context/Application';
import MapContext from '@/models/map-context/MapContext';
import { EventBus, EVENTS } from '@/services/EventBus';
import FileSaver from 'file-saver';
import Component from 'vue-class-component';
import BaseComponent from './BaseComponent';
import LayerConfig from '@/models/map-context/LayerConfig';
import LayerGroupConfig from '@/models/map-context/LayerGroupConfig';
import JSZip from "jszip";
import { transformExtent } from 'ol/proj.js';
import { boundingExtent } from 'ol/extent';

@Component
export default class Header extends BaseComponent {
  logoUrl = null;// = 'img/logo_pigma.png';
  canEdit=false;

  simpleHeader = false;

  created() {
    this.simpleHeader = this.contextService.simpleHeader;
  }

  edit() {
    this.contextService.startEdition();
    EventBus.$emit(EVENTS.OPEN_LEFT_SIDE_MENU, 'SettingsPanel');
    console.log(this.contextService.user);
  }

  deleteMap() {
    if (window.confirm('Confirmez vous la suppression de cette carte?')) {
      this.contextService.deleteCurrentMap().then((x) => this.$router.push({ path: '/maps' }));
    }
  }

  newMap() {
    if (!this.contextService.checkOrganization()) {
      return;
    }
    this.$router.push({ path: '/map/new' });
  }

  help() {
    window.open(this.contextService.configuration.documentation_url, 'target=help');
  }

  redirect(url:string) {
    window.location.href = url;
  }

  logout() {
    this.contextService.logout();
  }

  openContext() {
    const input:any = document.createElement('input');
    input.type = 'file';
    input.onchange = () => {
      // you can use this method to get file and perform respective operations
      const files = Array.from(input.files);
      console.log(files);
      if (files.length === 1) {
        const file:any = files[0];
        const reader = new FileReader();
        reader.addEventListener('load', (event:any) => {
          console.log(event.target.result);
          const appConfig = JSON.parse(event.target.result);
          console.log('loading ', appConfig);
          appConfig.id = undefined;
          appConfig.usergroup = undefined;
          appConfig.thumbnail = undefined;
          appConfig.creation_date = undefined;
          appConfig.last_revision_date = undefined;
          // store context before reload to route that will load it
          this.contextService.localApplication = new Application(appConfig);
          this.contextService.localContext = new MapContext(appConfig.config);
          const times:any = Date.now();
          this.$router.push({ path: '/map/new', query: { local: 'true', ts: times }, append: true });
        });
        reader.readAsText(file);
      }
    };
    input.click();
  }

  downloadContext() {
    const context = this.contextService.getJsonContext();
    const app:any = this.contextService.currentApplication;
    app.config = context;
    console.log(JSON.stringify(app));
    const blob = new Blob([JSON.stringify(app)],
      { type: 'text/plain;charset=utf-8' });
    FileSaver.saveAs(blob, 'context.json');
  }

  login() {
    // this.contextService.login(); DEV to remove
    const redirectUrl = window.location.pathname + window.location.search;
    if (this.contextService.termsValidationRequired) {
      this.redirect(`${this.contextService.getOneGeoLoginUrl()}/terms-of-use?next=${redirectUrl}`);
    } else if(this.contextService.getOneGeoLoginUrl().indexOf('portail')>=0 || this.contextService.getOneGeoLoginUrl().indexOf('explorer')>=0) {
      this.redirect(`${this.contextService.getOneGeoLoginUrl()}?next=${redirectUrl}`);
    }else {
      this.redirect(`${this.contextService.getOneGeoLoginUrl()}/signin?next=${redirectUrl}`);
    }
  }

  profile() {
    const redirectUrl = window.location.pathname + window.location.search;
    this.redirect(`${this.contextService.getOneGeoLoginUrl()}/profile?next=${redirectUrl}`);
  }

  cancelEdition() {
    this.contextService.cancelEdition();
    if (this.contextService.currentApplication && !this.contextService.currentApplication.id) {
      this.redirect('#/maps/');
    }
  }


  get mapTitle() {
    if (this.contextService.currentApplication !== null) {
      document.title = this.contextService.currentApplication.display_name;
      return this.contextService.currentApplication.display_name;
    }
    return '';
  }

  get canEditMap() {

    return this.contextService.canEditMap();
  }

  get canDeleteMap() {
    if (this.contextService.currentApplication
      && this.contextService.currentApplication.id
      && this.canEditMap) {
      return true;
    }

    return false;
  }



  saveContext() {
    this.contextService.checkAndSaveContext(this.$router);
  }

  mounted() {
    this.logoUrl = this.contextService.configuration.header.logo;
  }

  downloadMapToMapLibre() {
    const style = this.contextService.getJsonMapLibre();
    const blob = new Blob([JSON.stringify(style, null, 2)],
      { type: 'text/plain;charset=utf-8' });
    FileSaver.saveAs(blob, 'style.json');
  }

  openQgisFile() {
    if (!this.contextService.checkOrganization()) {
      return;
    }

    const self = this;
    const input:any = document.createElement('input');
    input.type = 'file';
    input.accept = '.qgs,.qgz';
    input.onchange = () => {
      const files = Array.from(input.files);
      if (files.length === 1) {
        const file:any = files[0];
        const extension = this.getFileExtension(file.name);

        if (!['qgs', 'qgz'].includes(extension!)) {
          return;
        }


        const isQgsFile = extension === "qgs";

        const reader = new FileReader();
        reader.onload = (event: any) => {
          let content = event.target.result;
          if(isQgsFile) {
            self.readQgis(content);
            return;
          }

          JSZip.loadAsync(content).then((zip: any) => {
            const qgsFiles = zip.file(/\.qgs$/i);
            if(qgsFiles.length) {
              qgsFiles[0].async('string').then((content: any) => self.readQgis(content))
            }
          })
        };

        if(isQgsFile) {
          reader.readAsText(file);
        } else {
          reader.readAsArrayBuffer(file);
        }
      }
    };
    input.click();
  }

  downloadMapToQgis() {
    const xml = this.contextService.getXmlQgis(this.getMapService().getMapExtent());
    const zip = new JSZip();
    zip.file('map.qgs', xml);
    zip.generateAsync({ type: 'blob' }).then(blob => FileSaver.saveAs(blob, 'map.qgz'))
  }

  getFileExtension(filename: string) {
    return filename.split('.').pop();
  }

  readQgis(content: string) {
    const domParser = new DOMParser();
    const xmlDoc = domParser.parseFromString(content, "text/xml");

    const root = xmlDoc.querySelector('qgis');
    if(!root) {
      return;
    }

    const eltProjectlayers = root.querySelector("projectlayers");
    if(! eltProjectlayers) {
      return;
    }

    const eltMapLayers = eltProjectlayers.querySelectorAll("maplayer");

    const layerTreeGroup = root.querySelector('layer-tree-group');
    if(! layerTreeGroup) {
      return;
    }

    let qgisExtent:any=this.getQGISExtent(root);
    this.contextService.localApplication = new Application();

    let context={
        version: "1.0",
        bbox:{
            "srs":this.getCrsQgis(root),
            "minx":qgisExtent[0],
            "miny":qgisExtent[1],
            "maxx":qgisExtent[2],
            "maxy":qgisExtent[3],
        },
        coords:[-1.34686,45.05679],
        zoom: 6.65,
        projection: "EPSG:3857",
        layers: []
      };
    this.addLayers(layerTreeGroup.children, eltMapLayers,context);
    this.contextService.localContext = new MapContext(context);
    const times:any = Date.now();
    this.$router.push({ path: '/map/new', query: { local: 'true', ts: times }, append: true });



  }
  getQGISExtent(qgisElt: any){
     const crsQgis = this.getCrsQgis(qgisElt);
    if(! crsQgis) {
      return;
    }

    const eltMapcanvas = qgisElt.querySelector("mapcanvas");
    if (! eltMapcanvas) {
      return;
    }

    const eltExtent = eltMapcanvas.querySelector("extent");
    if(! eltExtent) {
      return;
    }

    let extent = boundingExtent(
      [[Number(eltExtent.querySelector('xmin').textContent),
        Number(eltExtent.querySelector('ymin').textContent)],
      [Number(eltExtent.querySelector('xmax').textContent), 
      Number(eltExtent.querySelector('ymax').textContent)]]);
      return extent;
  }


  getCrsQgis(qgisElt: any) {
    const eltProjectCrs = qgisElt.querySelector("projectCrs");
    if (! eltProjectCrs) {
      return;
    }

    const eltSpatialrefsys = qgisElt.querySelector("spatialrefsys");
    if (! eltSpatialrefsys) {
      return;
    }

    return eltSpatialrefsys.querySelector('authid')?.textContent;
  }

  getParamsWfsLayerConfig(eltLayerTreeLayer: any, eltMapLayer: any) {
    const source = eltLayerTreeLayer.getAttribute("source");
    let aSource = source.split(' ');
    aSource = aSource.filter((strSrc: string) => Boolean(strSrc.trim()));

    aSource = aSource.map((strSource: string) => {
      const aData = strSource.split("='");
      if (aData.length !== 2) {
        return false;
      }
      return {
        key: aData[0],
        value: aData[1].replace(/\'$/g, '')
      };
    })

    const layers = aSource.find((aData: any) => aData.key === "typename");
    const srsname = aSource.find((aData: any) => aData.key === "srsname");
    const url = aSource.find((aData: any) => aData.key === "url");

    return {
      layername : layers?.value,
      title : eltMapLayer.querySelector("layername")?.textContent,
      type : "WFS",
      boundingBoxEPSG4326:[-175, -85, 175, 85],
      url : `${url?.value}?service=wfs&request=GetCapabilities`,
      visible: eltLayerTreeLayer.getAttribute("checked") === "Qt::Checked",
      isWfs: true,
      dataProjection: srsname?.value
    };
  }

  getParamsWmsOrWmtsLayerConfig(eltLayerTreeLayer: any, eltMapLayer: any) {
    const source = eltLayerTreeLayer.getAttribute("source");
    const sourceParams = new URLSearchParams(source);
    const url = sourceParams.get("url");
    if(! url) {
      return false;
    }

    return {
      layername : sourceParams.get("layers"),
      title : eltMapLayer.querySelector("layername")?.textContent,
      type : "WMS",
      url : url,
      outputFormat: sourceParams.get("format"),
      dataProjection: sourceParams.get("crs"),
      boundingBoxEPSG4326:[-175, -85, 175, 85],
      isWmts: url.toLowerCase().includes("wmts"),
      visible: eltLayerTreeLayer.getAttribute("checked") === "Qt::Checked",
    };
  }

  getParamsLayerConfig(eltLayerTreeLayer: any, eltMapLayer: any) {
    let providerKey = eltLayerTreeLayer.getAttribute("providerKey");
    if(! providerKey) {
      return false;
    }

    providerKey = providerKey.toLowerCase();
    if(providerKey === "wfs") {
      return this.getParamsWfsLayerConfig(eltLayerTreeLayer, eltMapLayer);
    } else if (providerKey === "wms" && eltLayerTreeLayer.getAttribute("name")=="OSM Standard") {
      return {
        layername: 'OSM',
        title: 'OSM',
        type: 'OSM',
        visible: true,
        boundingBoxEPSG4326: [-175, -85, 175, 85],
        Attribution: { Title: '© OpenStreetMap',OnlineResource:'https://www.openstreetmap.org/copyright'  },
      };
    }else if (providerKey === "wms") {
      return this.getParamsWmsOrWmtsLayerConfig(eltLayerTreeLayer, eltMapLayer);
    }

    return false;
  }

  addLayerTreeLayer(elLayerTreeLayer: any, findedEltMapLayer: any) {
    const params: any = this.getParamsLayerConfig(elLayerTreeLayer, findedEltMapLayer);
    if(! params) {
      return;
    }

    const newLayer = {
      ...params
    };

    if (params.isWfs) {
      //newLayer.url = newLayer.wmsUrlToWfs(newLayer.url);
      newLayer.outputFormat = 'application/json';
      newLayer.type='WFS';
    } else if (params.isWmts) {
      //CapabilitiesUrl();
      newLayer.type='WMTS';
      if (!newLayer.outputFormat) {
        newLayer.outputFormat = 'image/png';
      }
    }
    return newLayer;
  }

  addLayerTreeGroup(elLayerTreeGroup: any, eltMapLayers: any) {
    let oLayerGroupConfig:any = {
      title: elLayerTreeGroup.getAttribute("name") ?? "Nouveau Groupe",
      childs: [],
      visible: elLayerTreeGroup.getAttribute("checked") === "Qt::Checked"
    };

    const elLayerTreeGroupChildren = elLayerTreeGroup.children;
    for (let i = 0; i < elLayerTreeGroupChildren.length; i++) {
      const elLayerTreeGroupChild = elLayerTreeGroupChildren[i];
      const elLayerTreeGroupChildTagName = elLayerTreeGroupChild.tagName;

      if (elLayerTreeGroupChildTagName === "layer-tree-layer") {
        const findedEltMapLayer = Array.from(eltMapLayers).find((eltMapLayer: any) => eltMapLayer.querySelector("id").textContent === elLayerTreeGroupChild.getAttribute("id"))
        if(! findedEltMapLayer) {
          continue;
        }
        const newLayer:any = this.addLayerTreeLayer(elLayerTreeGroupChild, findedEltMapLayer);
        if (newLayer) {
          oLayerGroupConfig.childs.push(newLayer);
        }
      } else if (elLayerTreeGroupChildTagName === "layer-tree-group") {
        oLayerGroupConfig.childs.push(this.addLayerTreeGroup(elLayerTreeGroupChild, eltMapLayers));
      }
    }

    return oLayerGroupConfig;
  }

  addLayers(elLayerTreeGroupChildren: any, eltMapLayers: any,context:any){
    const tmpElLayerTreeGroupChildren = Array.from(elLayerTreeGroupChildren).reverse();

    for (let i = 0; i < tmpElLayerTreeGroupChildren.length; i++) {
      const elLayerTreeGroupChild: any = tmpElLayerTreeGroupChildren[i];
      const elLayerTreeGroupChildTagName = elLayerTreeGroupChild.tagName;

      if (elLayerTreeGroupChildTagName === "layer-tree-layer") {
        const findedEltMapLayer = Array.from(eltMapLayers).find((eltMapLayer: any) => eltMapLayer.querySelector("id").textContent === elLayerTreeGroupChild.getAttribute("id"))
        if(! findedEltMapLayer) {
          continue;
        }

        let newLayer= this.addLayerTreeLayer(elLayerTreeGroupChild, findedEltMapLayer)
        context.layers.unshift(newLayer);
      } else if (elLayerTreeGroupChildTagName === "layer-tree-group") {
        const newGroupLayer = this.addLayerTreeGroup(elLayerTreeGroupChild, eltMapLayers);
        context.layers.unshift(newGroupLayer);
      }
    }
  }
}
